import React from "react";

import { Icon } from "@iconify/react";

import type { ToastLink, ToastType } from "../api/toastBus";

type ToastProps = {
  isClosing?: boolean;
  link?: ToastLink;
  message: string;
  onClose: () => void;
  type: ToastType;
};

export const Toast: React.FC<ToastProps> = ({
  isClosing = false,
  link,
  message,
  onClose,
  type,
}) => {
  const isSuccess = type === "success";

  return (
    <div className={`toast ${isClosing ? "toast--closing" : ""}`} aria-live="polite" role="status">
      <div className={`toast__alert ${isSuccess ? "toast__alert--success" : ""}`}>
        <div className="toast__content">
          <Icon
            className="toast__icon"
            icon={isSuccess ? "solar:check-circle-bold" : "solar:danger-circle-bold"}
          />
          <div className="toast__body">
            <div className="toast__message">
              {message}
              {link && (
                <>
                  {" "}
                  <a
                    className="toast__link"
                    rel="noopener noreferrer"
                    href={link.url}
                    target="_blank"
                  >
                    {link.text}
                  </a>
                </>
              )}
            </div>
          </div>
        </div>
        <button
          className="toast__close"
          aria-label="Закрыть уведомление"
          onClick={onClose}
          title="Закрыть"
          type="button"
        >
          <Icon icon="solar:close-circle-bold" />
        </button>
      </div>
    </div>
  );
};
